// (c) chaehongee. Confidential and proprietary.

import { http, buildApiUrl } from './http'
import type {
    UserResponse,
    UserProfileUpdate,
    UserPreferences,
    UserPreferencesUpdate,
    UserCreditsResponse,
} from 'models-ts/user'

/**
 * Get current user profile
 */
export async function getUserProfile(): Promise<UserResponse> {
    return http<UserResponse>(buildApiUrl('/user/me'), {
        method: 'GET',
    })
}

/**
 * Update user profile (display name, avatar)
 */
export async function updateUserProfile(
    update: UserProfileUpdate
): Promise<UserResponse> {
    return http<UserResponse>(buildApiUrl('/user/profile'), {
        method: 'PATCH',
        body: JSON.stringify(update),
    })
}

/**
 * Update user preferences
 */
export async function updateUserPreferences(
    update: UserPreferencesUpdate
): Promise<UserPreferences> {
    return http<UserPreferences>(buildApiUrl('/user/preferences'), {
        method: 'PATCH',
        body: JSON.stringify(update),
    })
}

/**
 * Get user credits info
 */
export async function getUserCredits(): Promise<UserCreditsResponse> {
    return http<UserCreditsResponse>(buildApiUrl('/user/credits'), {
        method: 'GET',
    })
}

/**
 * Check if a user exists with the given email.
 */
export async function checkUserEmail(email: string): Promise<boolean> {
    const response = await http<{ exists: boolean }>(buildApiUrl('/user/check-email'), {
        method: 'POST',
        body: JSON.stringify({ email }),
    })
    return response.exists
}

